import(/* webpackMode: "eager" */ "/home/runner/work/techxeed-frontend/techxeed-frontend/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/techxeed-frontend/techxeed-frontend/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/techxeed-frontend/techxeed-frontend/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/techxeed-frontend/techxeed-frontend/public/assets/home/hero/butterflies-hero.png");
;
import(/* webpackMode: "eager" */ "/home/runner/work/techxeed-frontend/techxeed-frontend/public/assets/home/hero/category-hero.png");
;
import(/* webpackMode: "eager" */ "/home/runner/work/techxeed-frontend/techxeed-frontend/public/assets/home/hero/diagonals.png");
;
import(/* webpackMode: "eager" */ "/home/runner/work/techxeed-frontend/techxeed-frontend/public/assets/home/hero/leaves-color.png");
;
import(/* webpackMode: "eager" */ "/home/runner/work/techxeed-frontend/techxeed-frontend/public/assets/home/hero/leaves-grey.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/techxeed-frontend/techxeed-frontend/src/app/categories/[categoryId]/components/CategoryBannerSectorPillStrip.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/techxeed-frontend/techxeed-frontend/src/app/categories/[categoryId]/components/ChatNowFAB.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/techxeed-frontend/techxeed-frontend/src/app/categories/[categoryId]/components/ServiceList.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/techxeed-frontend/techxeed-frontend/src/app/components/ArrowLabel.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/techxeed-frontend/techxeed-frontend/src/app/components/DeferredHomeBlocks.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/techxeed-frontend/techxeed-frontend/src/app/components/PopularArticles/components/ArticlesCarousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/techxeed-frontend/techxeed-frontend/src/app/components/PopularServices/components/ServicesCarousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/techxeed-frontend/techxeed-frontend/src/components/analytics/TrackedCtaLink.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/techxeed-frontend/techxeed-frontend/src/components/animations/ScrollReveal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/techxeed-frontend/techxeed-frontend/src/components/faq/ExpandablePublicFaqAccordion.tsx");
